import * as React from 'react';

import { useApplicationContext } from '../ApplicationContext';
import { OldFiltersContainer } from './OldFiltersContainer';
import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend';

export const FiltersContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const isDesktopFiltersMicrofrontendEnabled = config.get<boolean>('DesktopFiltersMicrofrontend.Enabled') || false;

  return isDesktopFiltersMicrofrontendEnabled ? <DesktopFiltersMicrofrontend /> : <OldFiltersContainer />;
};
